export default "__VITE_ASSET__25c8cb72__"